module.exports = __webpack_public_path__ + "img/logo.765c7ebf.png";